import {
  ALL_LEASE_REQUEST,
  TRACTOR_VERIFIED,
  USER_LEASE_REQUEST,
  ASSIGNED_LEASE_REQUEST,
  TRACTOR_ASSIGNED_SUCCESSFULLY,
  PENDING_LEASE_REQUEST,
  ALL_FARMERS,
  ALL_AGENTS,
} from "../actions/action.types";

const initialState = {
  verified_tractor: {}, //TODO: find out if a boolean can be used here
  allLeaseRequest: [],
  allUserLeaseRequest: [],
  allAssignedLease: [],
  allPendingLease: [],
  tractorAssigned: {}, //TODO: change to the appropriate data type
};

const leasingReducer = (state = initialState, action) => {
  switch (action.type) {
    case TRACTOR_VERIFIED:
      return {
        ...state,
        verified_tractor: action.payload,
      };
    case ALL_LEASE_REQUEST:
      return {
        ...state,
        allLeaseRequest: action.payload,
      };
    case ALL_FARMERS:
      return {
        ...state,
        allFarmers: action.payload,
      };
    case ALL_AGENTS:
      return {
        ...state,
        allAgents: action.payload,
      };
    case USER_LEASE_REQUEST:
      return {
        ...state,
        allUserLeaseRequest: action.payload,
      };
    case ASSIGNED_LEASE_REQUEST:
      return {
        ...state,
        allAssignedLease: action.payload,
      };
    case PENDING_LEASE_REQUEST:
      return {
        ...state,
        allPendingLease: action.payload,
      };
    case TRACTOR_ASSIGNED_SUCCESSFULLY:
      return {
        ...state,
        tractorAssigned: action.payload,
      };
    default:
      return state;
  }
};

export default leasingReducer;
